import {
    VIEW_CEREBRUMX_INTEGRATION_REQUEST,
    VIEW_CEREBRUMX_INTEGRATION_RESULT,
    VIEW_CEREBRUMX_INTEGRATION_OPEN_MODAL,
    VIEW_CEREBRUMX_INTEGRATION_CLOSE_MODAL,
    VIEW_CEREBRUMX_INTEGRATION_GET_INTEGRATION_REQUEST,
    VIEW_CEREBRUMX_INTEGRATION_GET_INTEGRATION_RESULT,
    VIEW_CEREBRUMX_INTEGRATION_SET_INTEGRATIONS,
    VIEW_CEREBRUMX_INTEGRATION_SAVE_PROFILE_REQUEST,
    VIEW_CEREBRUMX_INTEGRATION_SAVE_PROFILE_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    loading: false,
    openModal: false,
    result: null,
    error: null,
    companyIntegration: null,
    fleet: null,
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case VIEW_CEREBRUMX_INTEGRATION_REQUEST:
            return { ...state, loading: true }

        case VIEW_CEREBRUMX_INTEGRATION_RESULT:
            return { ...state, loading: false, result: action.payload }

        case VIEW_CEREBRUMX_INTEGRATION_OPEN_MODAL:
            return { ...state, openModal: true }

        case VIEW_CEREBRUMX_INTEGRATION_CLOSE_MODAL:
            return { ...state, openModal: false }

        case VIEW_CEREBRUMX_INTEGRATION_GET_INTEGRATION_REQUEST:
            return { ...state, loading: true }

        case VIEW_CEREBRUMX_INTEGRATION_GET_INTEGRATION_RESULT:
            return { ...state, loading: false, companyIntegration: action.payload.companyIntegration, fleet: action.payload.fleet }

        case VIEW_CEREBRUMX_INTEGRATION_SET_INTEGRATIONS:
            return { ...state, devices: action.payload }

        case VIEW_CEREBRUMX_INTEGRATION_SAVE_PROFILE_REQUEST:
            return { ...state, loading: true }

        case VIEW_CEREBRUMX_INTEGRATION_SAVE_PROFILE_RESULT:
            return { ...state, loading: false, result: action.payload }

        case CLEAR_REDUX:
            return ["", "VIEW_CEREBRUMX_INTEGRATION"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};